import { useQuery } from "@apollo/client/react";
import { GET_ACTIVE_USERS } from "@/hooks";
import type { ActiveUserType } from "@/types/graphql";

type ActiveUsersListQueryData = {
  activeUsers?: Array<ActiveUserType | null> | null;
  comActiveUsers?: Array<ActiveUserType | null> | null;
};

/**
 * Hook to fetch active users list
 * @param {string} searchString - Optional search string to filter users
 * @returns {Object} - Returns activeUsersList array and loading state
 */
export function useActiveUsersList(searchString: string) {
  const { data, loading } = useQuery(GET_ACTIVE_USERS, {
    variables: {
      searchString: searchString || null,
    },
    pollInterval: 60000,
  });

  return {
    activeUsersList:
      (data as ActiveUsersListQueryData)?.activeUsers ||
      (data as ActiveUsersListQueryData)?.comActiveUsers ||
      [],
    loading,
  };
}
